import React, { Component } from "react";
import { injectIntl } from "react-intl";
import _debounce from "lodash/debounce";
import { Grid } from "@material-ui/core";
import { withTheme, withStyles } from "@material-ui/core/styles";
import {
  withModulesManager,
  TextInput,
  PublishedComponent,
} from "@openimis/fe-core";
import EnrollmentStatusPicker from "./EnrollmentStatusPicker";

const styles = (theme) => ({
  form: {
    padding: 0,
  },
  item: {
    padding: theme.spacing(1),
  },
});

class EnrollmentFilter extends Component {
  debouncedOnChangeFilter = _debounce(
    this.props.onChangeFilters,
    this.props.modulesManager.getConf("fe-enrollment", "debounceTime", 200)
  );

  _filterValue = (k) => {
    const { filters } = this.props;
    return !!filters && !!filters[k] ? filters[k].value : null;
  };

  _filterTextFieldValue = (k) => {
    const { filters } = this.props;
    return !!filters && !!filters[k] ? filters[k].value : "";
  };

  render() {
    const { classes, onChangeFilters } = this.props;
    return (
      <Grid container className={classes.form}>
        <Grid item xs={3} className={classes.item}>
          <TextInput
            module="enrollment"
            label="filter.search"
            name="search"
            value={this._filterTextFieldValue("search")}
            onChange={(v) =>
              this.debouncedOnChangeFilter([
                {
                  id: "search",
                  value: v,
                  filter: v ? `search: "${String(v).replace(/"/g, '\\"')}"` : null,
                },
              ])
            }
          />
        </Grid>
        <Grid item xs={3} className={classes.item}>
          <EnrollmentStatusPicker
            value={this._filterValue("status")}
            withNull={true}
            onChange={(v) =>
              onChangeFilters([
                {
                  id: "status",
                  value: v,
                  // Enum argument — unquoted (e.g. status: DRAFT)
                  filter: v ? `status: ${v}` : null,
                },
              ])
            }
          />
        </Grid>
        <Grid item xs={3} className={classes.item}>
          <PublishedComponent
            pubRef="core.DatePicker"
            module="enrollment"
            label="filter.dateFrom"
            value={this._filterValue("dateCreatedFrom")}
            onChange={(v) =>
              onChangeFilters([
                {
                  id: "dateCreatedFrom",
                  value: v,
                  filter: v ? `dateCreated_Gte: "${v}"` : null,
                },
              ])
            }
          />
        </Grid>
        <Grid item xs={3} className={classes.item}>
          <PublishedComponent
            pubRef="core.DatePicker"
            module="enrollment"
            label="filter.dateTo"
            value={this._filterValue("dateCreatedTo")}
            onChange={(v) =>
              onChangeFilters([
                {
                  id: "dateCreatedTo",
                  value: v,
                  filter: v ? `dateCreated_Lte: "${v}"` : null,
                },
              ])
            }
          />
        </Grid>
      </Grid>
    );
  }
}

export default withModulesManager(
  injectIntl(withTheme(withStyles(styles)(EnrollmentFilter)))
);
